<div id="app-navigation" [class.expanded]="!isSidebarCollapsed">
    <ng-container *ngFor="let navList of appNavigation; let i = index">
        <nav [id]="'app-navigation-section-' + i" class="nav-list">
            <ng-container *ngFor="let navItem of navList">
                <a
                    *ngIf="!navItem.submenu"
                    [pTooltip]="isSidebarCollapsed ? (navItem.label | translate) : ''"
                    [routerLink]="[navItem.url]"
                    [routerLinkActive]="['active-link']"
                    [routerLinkActiveOptions]="{ exact: true }"
                    [id]="navItem.id + '-nav-link'"
                    class="nav-link">
                    <ng-container
                        [ngTemplateOutlet]="navLink"
                        [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                </a>

                <button
                    *ngIf="navItem.submenu"
                    (click)="navItemClick(navItem)"
                    [id]="navItem.id + '-nav-link'"
                    class="nav-link">
                    <ng-container
                        [ngTemplateOutlet]="navLink"
                        [ngTemplateOutletContext]="{ navItem: navItem }"></ng-container>
                </button>

                <nav
                    [ngClass]="navItem.expanded ? 'submenu-expanded' : 'submenu-collapsed'"
                    class="submenu"
                    [id]="navItem.id + '-submenu'"
                    tabindex="-1">
                    <a
                        *ngFor="let submenuItem of navItem.submenu"
                        [routerLink]="[submenuItem.url]"
                        [routerLinkActive]="['active-submenu-link']"
                        [routerLinkActiveOptions]="{ exact: true }"
                        [id]="submenuItem.id + '-submenu-nav-link'"
                        [tabindex]="!navItem.expanded ? '-1' : '0'"
                        class="submenu-link">
                        <div class="btn-icon" [id]="submenuItem.id + '-submenu-icon'">
                            <i [class]="submenuItem.icon"></i>
                        </div>
                        <span class="nav-label" [id]="submenuItem.id + '-submenu-label'">{{
                            submenuItem.label | translate
                        }}</span>
                    </a>
                </nav>
            </ng-container>
        </nav>
    </ng-container>
</div>

<ng-template #navLink let-navItem="navItem">
    <div class="btn-icon" [id]="navItem.id + '-icon'">
        <i [class]="navItem.icon"></i>
    </div>
    <span class="nav-label" [id]="navItem.id + '-label'">{{ navItem.label | translate }}</span>
    <div *ngIf="navItem.submenu" class="expand-btn-container">
        <button
            [id]="navItem.id + '-expand-submenu-btn'"
            aria-label="Toggle menu"
            tabindex="-1"
            pButton
            class="p-button-rounded p-button-text expand-menu-btn p-button-secondary">
            <i class="fa-light" [ngClass]="navItem.expanded ? 'fa-angle-up' : 'fa-angle-down'"></i>
        </button>
    </div>
</ng-template>
